export const FEATURE_FLAGS = {
  EXAMPLE_FLAG_NAME: 'example-flag-name',
  SUGGESTED_TREATMENTS_SCREEN: 'suggested-treatments-screen',
  MOBILE_APPOINTMENT_CALENDAR: 'mobile-appointment-calendar',
} as const

export const VARIANT_KEYS = {
  CONTROL: 'control',
  TEST: 'test',
}
